import React from 'react';
import Widgets from '../Widgets';
import { BarChart, InfoBlock, CustomFilter } from '../../../components';
import { isEqual } from 'lodash';
import { Range, createSliderWithTooltip } from 'rc-slider';
import moment from 'moment-timezone';
import { sumByField } from '../../../helpers';

import './WidgetBarChartWithSlider.css';

const RangeWithTooltip = createSliderWithTooltip(Range);

export default class WidgetBarChartWithSlider extends Widgets {
  componentDidUpdate(props, state) {
    if (
      (!isEqual(this.props.filters, props.filters) || ((this.state && state) && !isEqual(this.state.extraFilters, state.extraFilters)) || this.props.shouldLoadData)
      && (this.props.filtersLoaded)
    ){
      this.setState({sliderLabels: undefined, sliderRange: undefined})
      this.props.fetchData({
        ...this.props.filters,
        ...(this.state ? this.state.extraFilters : {})
      }, `${this.props.id}Extra`)
      this.props.fetchLegendData({
        ...this.props.filters,
        ...(this.state ? this.state.extraFilters : {}),
        metric: 'lp_session_tm'
      }, `${this.props.id}Legend0`);
      this.props.fetchLegendData({
        ...this.props.filters,
        ...(this.state ? this.state.extraFilters : {}),
        metric: 'lp_load_tm'
      }, `${this.props.id}Legend1`);
      return this.props.fetchData({
        ...this.props.filters,
        ...(this.state ? this.state.extraFilters : {})
      }, this.props.id)
    }
  }

  onSliderChange = (value) => {
    const marks = this.props.graph.reduce((acc, curr, idx) => ({
      ...acc,
      [(100 / this.props.graph.length) * idx]: curr.date
    }), {})
    this.setState({ sliderRange: value, sliderLabels: [marks[value[0]], marks[value[1]]]})
  }

  onSliderAfterChange = (value) => {
    moment.tz.setDefault(this.props.filters.tz)
    const secondsInRange = Math.abs(moment(this.props.graph[0].date).diff(this.props.graph[this.props.graph.length - 1].date, 'seconds'));
    const leftSecondsPercentile = secondsInRange * (value[0] / 100);
    const rightSecondsPercentile = secondsInRange * (value[1] / 100);
    const labels = [moment(this.props.graph[0].date).add(leftSecondsPercentile, 'seconds').format(),moment(this.props.graph[0].date).add(rightSecondsPercentile, 'seconds').format()]
    this.props.fetchData({
      ...this.props.filters,
      startDate: labels[0],
      endDate: labels[1],
      exactRanges: true,
      ...(this.state ? this.state.extraFilters : {})
    }, `${this.props.id}Extra`)
    this.props.fetchLegendData({
      ...this.props.filters,
      startDate: labels[0],
      endDate: labels[1],
      ...(this.state ? this.state.extraFilters : {}),
      metric: 'lp_session_tm'
    }, `${this.props.id}Legend0`);
    this.props.fetchLegendData({
      ...this.props.filters,
      startDate: labels[0],
      endDate: labels[1],
      ...(this.state ? this.state.extraFilters : {}),
      metric: 'lp_load_tm'
    }, `${this.props.id}Legend1`);
  }

  onCustomFilterChange = (items) => {
    const extraFilters = items.reduce((acc, curr) => ({
      ...acc,
      ...(curr.value.split('=').length === 2 && this.props.customFilterAcceptedParams.includes(curr.value.split('=')[0]) ? {[curr.value.split('=')[0]]: curr.value.split('=')[1]} : {})
    }), {});
    this.setState({ extraFilters, selectedFilters: items.filter(item => item.value.split('=').length === 2 && this.props.customFilterAcceptedParams.includes(item.value.split('=')[0])) });
  }

  onDateSliderChange = (value) => {
    moment.tz.setDefault(this.props.filters.tz)
    const secondsInRange = Math.abs(moment(this.props.graph[0].date).diff(this.props.graph[this.props.graph.length - 1].date, 'seconds'));
    const leftSecondsPercentile = secondsInRange * (value[0] / 100);
    const rightSecondsPercentile = secondsInRange * (value[1] / 100);
    const labels = [moment(this.props.graph[0].date).add(leftSecondsPercentile, 'seconds').format(),moment(this.props.graph[0].date).add(rightSecondsPercentile, 'seconds').format()]
    this.setState({ sliderRange: value, sliderLabels: labels})
  }

  render() {
    if (this.props.loaded && this.props.graph && this.props.graph.length) {
      const step = 100 / Math.abs(moment(this.props.graph[0].date).diff(this.props.graph[this.props.graph.length - 1].date, 'hours'));

      const secondsInRange = Math.abs(moment(this.props.graph[0].date).diff(this.props.graph[this.props.graph.length - 1].date, 'seconds'));

      return (
        <div className={this.props.className ? `${this.props.className} WidgetBarChartWithSlider` : 'WidgetBarChartWithSlider'} style={this.props.style}>
          <h1 className="title">{this.props.title}</h1><span className="actions">{this.props.onZoom ? <a onClick={this.props.onZoom}><i className="fa fa-search"></i></a> : null}<a onClick={this.downloadDataAsCSV}><i className="fa fa-download"></i></a></span>
          {this.props.customFilter ? <CustomFilter className="CustomFilter" selected={this.state && this.state.selectedFilters ? this.state.selectedFilters : []} onChange={this.onCustomFilterChange} acceptedParams={this.props.customFilterAcceptedParams} /> : null}
          <div style={{'width': '90%', 'float': 'left'}}>
            <BarChart
              colorScheme={this.props.colorScheme}
              data={this.props.graph ? this.props.graph : []}
              size={[this.props.info && this.props.info.length ? this.props.width * 0.8 : this.props.width * 0.95, this.props.height * 0.35]}
              filters={{
                ...this.props.filters,
                ...(this.state ? this.state.extraFilters : {})
              }}
              ranges={this.state.sliderLabels}
            />
            {this.props.graph && this.props.graph.length ? <RangeWithTooltip
              style={{marginLeft: '50px'}}
              onChange={this.onDateSliderChange}
              min={0}
              max={100}
              defaultValue={[0, 100]}
              marks={{
                0: moment(this.props.graph[0].date).format(),
                20: moment(this.props.graph[0].date).add(Math.ceil((secondsInRange * .2) / 3600), 'hours').format(),
                40: moment(this.props.graph[0].date).add(Math.ceil((secondsInRange * .4) / 3600), 'hours').format(),
                60: moment(this.props.graph[0].date).add(Math.ceil((secondsInRange * .6) / 3600), 'hours').format(),
                80: moment(this.props.graph[0].date).add(Math.ceil((secondsInRange * .8) / 3600), 'hours').format(),
                100: moment(this.props.graph[this.props.graph.length - 1].date).format()
              }}
              tipFormatter={value => {
                moment.tz.setDefault(this.props.filters.tz)
                const secondsPercentile = secondsInRange * (value / 100);
                return moment(this.props.graph[0].date).add(secondsPercentile, 'seconds').format();
              }}
              onAfterChange={this.onSliderAfterChange}
              trackStyle={[{ backgroundColor: this.props.colorScheme[0] }]}
              handleStyle={[{ borderColor: this.props.colorScheme[0] }, { borderColor: this.props.colorScheme[0] }]}
              activeDotStyle={{ borderColor: this.props.colorScheme[0] }}
              step={step}
            /> : null }
            <div style={{position: 'absolute', bottom: '60px'}}>
              <BarChart
                colorScheme={this.props.colorScheme}
                data={this.props.extraGraphData ? this.props.extraGraphData : []}
                size={[this.props.width * 0.6, this.props.height * 0.6]}
                tooltipData={this.props.extraGraphTooltipData ? this.props.extraGraphTooltipData : []}
                textAbove
                filters={{
                  ...this.props.filters,
                  ...(this.state ? this.state.extraFilters : {})
                }}
              />
            </div>
            <div className="infoBlocks" style={{'width': this.props.width * 0.15}}>
                {this.props.legendData ? this.props.legendData.map((item, idx) => (
                  <div>
                    {idx !== 0 ? <hr /> : null}
                    <InfoBlock {...item} />
                  </div>
                )) : null}
            </div>
          </div>
        </div>
      );
    } else if (!this.props.loaded && this.props.filtersLoaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetChartNumeric` : 'WidgetChartNumeric'} style={this.props.style}>
          <img src={`${process.env.PUBLIC_URL}/loading.svg`} />
        </div>
      );
    else
      return (
        <div className={this.props.className ? `${this.props.className} WidgetChartNumeric` : 'WidgetChartNumeric'} style={this.props.style}>
          <h1>select operator and service to see stats</h1>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Widgets/WidgetBarChartWithSliderComponent/WidgetBarChartWithSlider.js